import {Component, Inject, Optional} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-payment-reversal-refund-confirmation',
  templateUrl: './payment-reversal-refund-confirmation.component.html',
  styleUrls: ['./payment-reversal-refund-confirmation.component.scss']
})
export class PaymentReversalRefundConfirmationComponent {
  public totalCount: number = 0;
  public totalAmount: number = 0;

  constructor(public dialogRef: MatDialogRef<PaymentReversalRefundConfirmationComponent>,
              @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.totalCount = this.data.totalCount;
    this.totalAmount = this.data.totalAmount;
  }

  public close(result?: boolean) {
    this.dialogRef.close(result);
  }
}
